"use client";

import { MapPin, Tag } from "lucide-react";

const HappeningCard = ({
  image,
  imageAlt = "Event Image",
  category,
  link,
  title,
  description,
  dateTime,
  location,
  time,
  date,
  onGetDirection = () => {}
}) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border overflow-hidden mb-4 w-full max-w-[280px] sm:max-w-[280px] md:max-w-[280px] lg:max-w-[280px]">
      <div className="h-[420px] flex flex-col">
        <div className="relative h-48 w-full flex-shrink-0">
          <img
            src={image || "/placeholder.svg"}
            alt={imageAlt}
            className="w-full h-full object-cover"
          />
          {category && (
            <div className="absolute top-3 left-3 bg-white/90 text-gray-800 text-xs font-medium px-2.5 py-1.5 rounded-md shadow-sm flex items-center gap-1.5">
              {category.icon || <Tag className="h-3 w-3" />} {category.name}
            </div>
          )}
        </div>
        <div className="p-4 flex flex-col flex-grow">
          <h3
            onClick={() => window.open(link, "_blank")}
            className="cursor-pointer font-bold text-xl text-gray-900 line-clamp-1 h-[28px] overflow-hidden"
          >
            {title}
          </h3>
          <p className="text-sm text-gray-600 mt-1 mb-auto line-clamp-2 h-[40px] overflow-hidden">
            {description}
          </p>

          <div className="flex items-start mt-3">
            <div className="flex-1 flex items-center text-sm text-gray-600">
              <MapPin className="h-4 w-4 mr-1.5 text-gray-500 flex-shrink-0" />
              <span className="line-clamp-2">{location}</span>
            </div>
            <div className="mx-2 h-12 border-r border-gray-200" />

            <div className="flex-1">
              <div className="text-sm text-gray-500">
                {date && typeof date === "object"
                  ? `${date.day} ${date.month} ${date.year}`
                  : date}
              </div>
              <div className="text-sm  text-gray-800">
                {time}
              </div>
            </div>
          </div>

          <button
            className="mt-4 w-full py-2.5 bg-transparent border border-gray-300 text-gray-800 rounded-lg text-sm font-medium transition-colors hover:bg-[#7B189F] hover:border-[#7B189F] hover:text-white active:bg-[#6a1587] flex items-center justify-center gap-1"
            onClick={onGetDirection}
          >
            Get Direction
          </button>
        </div>
      </div>
    </div>
  );
};

export default HappeningCard;
